<template>
  <v-snackbar
    v-model="$store.state.ui.snackbar.show"
    top
    dense
    :color="options.color"
    class="pt-12 mt-4 black--text snackbar-zIndex text-break"
    :timeout="20000"
    :class="options.classes"
    @input="inputHandler"
  >
    <v-icon
      :color="options.icon.color"
      class="pr-2 mt-2"
    >
      {{ options.icon.code }}
    </v-icon>
    <div class="mt-2">
      <h3>{{ title }}</h3>
      <span v-html="message" />
    </div>
    <v-spacer />
    <v-btn
      v-if="this.$store.state.ui.snackbar.controller !== ''"
      v-track="'undo-archive-action'"
      class="pt-3"
      text
      color="black"
      @click="clickHandler"
    >
      <span class="font-weight-bold">UNDO</span>
    </v-btn>
    <v-btn
      text
      icon
      color="#716563"
      class="ml-0"
      @click="close"
    >
      <v-icon size="20">
        close
      </v-icon>
    </v-btn>
  </v-snackbar>
</template>
<script>
  export default {
    name: 'SnackBar',
    props: {
      snackBar: {
        default: '',
        type: String,
        message: String,
        title: String,
        timeout: Number,
      },
    },
    data () {
      return {
        snackbar: true,
      }
    },
    computed: {
      options () {
        const options = {
          icon: {
            code: '',
            color: '',
          },
          color: 'blue lighten-4',
          classes: {
            success_status: false,
            error_status: false,
            warning_status: false
          },
        }

        switch (this.$store.state.ui.snackbar.type) {
          case 'success':
            options.color = 'green lighten-4'
            options.icon.code = 'check_circle_outline'
            options.icon.color = 'green'
            options.classes.success_status = true
            break

          case 'error':
            options.color = '#f8dddc'
            options.icon.code = 'error_outline'
            options.icon.color = '#9E2020'
            options.classes.error_status = true
            break

          case 'warning':
            options.color = '#fff2cc'
            options.icon.code = 'mdi-information-outline'
            options.icon.color = '#2F3643'
            options.classes.warning_status = true
            break

          default:
            options.color = 'blue lighten-4'
        }

        return options
      },
      message () {
        return this.$store.state.ui.snackbar.message
      },
      title () {
        return this.$store.state.ui.snackbar.title
      },
    },
    methods: {
      close () {
        this.$store.state.ui.snackbar.show = false
      },
      inputHandler () {
        if (!this.$store.state.ui.snackbar.show) {
          this.$store.commit('ui/snackbar.reset')
        }
      },
      clickHandler(){
        switch (this.$store.state.ui.snackbar.controller) {
          case 'ctags':
            this.$root.$emit('triggerCtagArchive')
          break;
          case 'dynamic_content':
            this.$root.$emit('triggerDynamicArchive')
          break;
          case 'contents':
            this.$root.$emit('triggerContentArchive')
          break;
          case 'lists':
            this.$root.$emit('triggerListArchive')
          break;
          case 'segments':
            this.$root.$emit('triggerSegmentArchive')
          break;
        }
      }
    },
  }
</script>
<style>
  .v-snack__content{
    justify-content: start !important;
    display: flex !important;
    align-items: start !important;
    border-width: 1px;
    border-style: solid;
    border-radius: 3px;
  }
  .error_status .v-snack__content {
    border-color: #F39191;
  }
  .success_status .v-snack__content {
    border-color: #41CE65;
  }
  .warning_status .v-snack__content {
    border-color: #fff2cc;
  }
  .snackbar-zIndex{
    z-index: 9999 !important;
  }
</style>
